import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openLogOutTab(event) {
    if(event.detail[0]) {
      window.open("https://www.airbnb.com/logout")
    }
  }
}
